import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Heading as DefaultHeading,
  Progress,
  Button,
  ProductList,
  ProductListItem,
  ProductListItemHeading,
  ProductListItemMetadata,
  ProductListItemProgressContainer,
  ProductListItemActionsContainer,
  ProductListItemHeadingCell,
} from 'prospect-path-components';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import moment from 'moment-timezone';
import { history } from '../../store';
import NotFound from '../not-found';
import BlankProductPage from '../../pages/blank-states/products';
import ConfirmProduct from '../../components/product-management/modals/ConfirmProduct';

const Heading = styled(DefaultHeading)`
  font-size: 2.5rem;
  display: inline-block;
`;

const HeadingButtonContainer = styled.div`
  float: right;
  margin-top: 1.4em;
`;

const HeadingButtonItem = styled.div`
  display: inline-block;
  margin: 1em;
`;

class YourProducts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hoveredItem: null,
      productModalProductId: null,
    };

    this.getTeamId = this.getTeamId.bind(this);
    this.getTeam = this.getTeam.bind(this);
    this.getProductModalProduct = this.getProductModalProduct.bind(this);
    this.openProductModal = this.openProductModal.bind(this);
    this.closeProductModal = this.closeProductModal.bind(this);
    this.manageProduct = this.manageProduct.bind(this);
  }

  componentDidMount() {
    document.title = 'Products | Prospect Path';

    const confirmModalProductId = new URLSearchParams(window.location.search).get('confirmProduct');
    if (confirmModalProductId && confirmModalProductId.length > 0) {
      this.openProductModal(parseInt(confirmModalProductId));
    }
  }

  getTeamId() {
    return window.currentTeamId;
    // return parseInt(this.props.currentTeamId);
  }
  getTeam() {
    return window.currentTeam;
    // return this.props.teams.find(team => team.id === this.getTeamId());
  }
  getProductModalProduct() {
    const team = this.getTeam();
    if (team == null) {
      return null;
    }

    return team.products.find(product => product.id === this.state.productModalProductId);
  }
  openProductModal(productId) {
    this.setState({ productModalProductId: productId });
  }
  closeProductModal() {
    this.setState({ productModalProductId: null });
  }
  manageProduct(productId) {
    if (this.props.user.is_vendor_pending === false) {
     return  history.push(`/products/${productId}`);
    }
    return this.openProductModal(productId);
  }

  render() {
    if (this.props.user.id === null) {
      window.location = '/signup/product';
    }
    // if (this.props.loadingTeams) {
    //   return '';
    // }
    // if (!this.props.loadingTeams && !this.props.userTeams.includes(this.getTeamId())) {
    //   return <NotFound />;
    // }

    const team = this.getTeam();
    let products = '';
    let hasProducts = true;
    if (team) {
      hasProducts = team.products.length > 0;
      products = (
        <ProductList style={{ clear: 'both' }}>
          {team.products.map(product => (
            <ProductListItem
              onMouseEnter={() => { this.setState({ hoveredItem: product.id }); return true; }}
              onMouseLeave={() => { this.setState({ hoveredItem: null }); }}
              key={product.id}
            >
              <ProductListItemHeadingCell>
                <ProductListItemHeading>
                  {product.name}
                </ProductListItemHeading>
                <ProductListItemMetadata>
                  Last updated {moment.tz(product.updated_at, 'UTC').local().format('MMMM Do YYYY -  HH:mm')}
                </ProductListItemMetadata>
              </ProductListItemHeadingCell>
              <ProductListItemActionsContainer>
                <ProductListItemProgressContainer>
                  <Progress progress={product.percent_complete} />
                </ProductListItemProgressContainer>

                <Button color={this.state.hoveredItem === product.id ? 'primary' : ''} onClick={() => this.manageProduct(product.id)}>Manage Product</Button>
              </ProductListItemActionsContainer>
            </ProductListItem>
          ))}
        </ProductList>
      );
    }

    if (!hasProducts) {
      products = <BlankProductPage />;
    }

    return (
      <div>
        <div className="l-wrapper-content">
          <section className="l-wrapper-container">

            <header className="l-billing-header">
              <div>
                <Heading>Your Products</Heading>
                <HeadingButtonContainer>
                  {
                     // Manage user products which is currently disabled
                     // this.getTeam().user_role === 'super_admin' &&
                     // <HeadingButtonItem>
                     //   <Button onClick={() => history.push(`/products/users`)}>
                     //       Manage Team Users
                     //   </Button>
                     // </HeadingButtonItem>
                  }
                  <HeadingButtonItem>
                    <Button color="primary" onClick={() => history.push('/products/add')}>Add product</Button>
                  </HeadingButtonItem>
                </HeadingButtonContainer>
              </div>
            </header>
            {products}
          </section>
        </div>
        {typeof this.getProductModalProduct() !== 'undefined' &&
          <ConfirmProduct
            isOpen={this.state.productModalProductId != null}
            product={this.getProductModalProduct()}
            closeModal={this.closeProductModal}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  // teams: state.teams.all,
  currentTeamId: state.teams.currentTeam,
  userTeams: state.teams.userTeams,
  // loadingTeams: state.teams.loadingTeams,
});

const mapDispatchToProps = dispatch => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(YourProducts));
